import React, { useContext, useEffect } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { Outlet, useOutletContext, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ApiContext from 'api/ApiContext';
import { PollDaysResponse } from 'api/api.types';
import { Pagesection, Contentheader, Loading } from '@ktag/styleguide/dist/react';
import WAPBreadcrumbs from 'lib/WAPBreadcrumbs/WAPBreadcrumbs';
import BreadcrumbsContext from 'lib/WAPBreadcrumbs/BreadcrumbsContext';
import useTrackPageView from 'utils/useTrackPageView';
import OverviewToggle from './OverviewToggle';

const Overview = () => {
  const { t } = useTranslation('wap');
  const { pathname } = useLocation();
  useTrackPageView();
  const { getPollDays } = useContext(ApiContext);
  const { setBreadcrumbItems } = useContext(BreadcrumbsContext);
  const query = useQuery(['polling_days'], getPollDays);

  const currentPoll = query.data?.data?.[0];

  useEffect(() => {
    if (pathname === '/') {
      setBreadcrumbItems([]);
    } else {
      setBreadcrumbItems([
        {
          title: t('archive'),
          url: '/archiv',
        },
      ]);
    }
  }, [pathname]);

  return (
    <>
      <Pagesection>
        <Contentheader
          beforeBreadcrumbs={<WAPBreadcrumbs />}
          pagetitle={t('overview_title')}
          printing={!query.isLoading}
        />
        {query.isLoading && <Loading size="big" />}
        {query.isError && <p>Error</p>}
        {query?.data && <OverviewToggle currentDate={currentPoll?.date} />}
      </Pagesection>
      {query?.data && <Outlet context={{ query }} />}
    </>
  );
};

export const usePollDays = () => {
  return useOutletContext<{
    query: UseQueryResult<PollDaysResponse, unknown>;
  }>();
};

export default Overview;
